import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { ViewportScroller } from '@angular/common';
import { ApiService } from '../api.service';

import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit, OnDestroy {
    currBaseURL: any;
    visible:boolean = false;

    inputTrackingNumber:any="";
    inputSenderContactNumber:any="";
    inputReceiverContactNumber:any="";
    inputAccountNumber:any="";

    pageUrl:String;
    paramsSub: Subscription;
    trackPage:boolean=false;
    proofPage:boolean=false;
    trackPageOrigin:boolean=false;
    proofPageOrigin:boolean=false;
    fontColor1:String;
    fontColor2:String;
    transformValue:any;

    //track
    trackerList:any;
    trackerListRecon:any = [];
    trackCode:any = "";
    trackerDisplay:boolean = false;
    proofDisplay:boolean = false;
    imageTracker:string = "./assets/image/TRACKING/BOOKED.png";
    trackerArr: any;
    elementId: string="";
  
  toggleStatus:any="DEFAULT";

  constructor(
    private titleService: Title,
    private apiService: ApiService,
    private viewportScroller: ViewportScroller,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {

   }

  ngOnInit(): void {
    this.titleService.setTitle("Tracking| Line Clear Express")
    //**** note: Input pass in Track Shipment by another system*/
     // console.log('URL 2: '+ location.href);
     if(location.href.includes('id=') ){
        this.elementId = location.href.substring(location.href.indexOf("=") + 1);
        this.elementId =  this.elementId.replace("_",",")
        this.trackCode = this.elementId
        //console.log("this.trackCode",this.trackCode);
        this.clicked("track");
        this.trackCode = this.elementId
        this.getTrackerData("");
               
        }
        else{
            //do nothing
        }

    this.paramsSub = this.activeRoute.params.subscribe(val => {
        // Handle param values here
        this.pageUrl=sessionStorage.getItem("subComponent");
        sessionStorage.removeItem("subComponent");

        
        if(this.pageUrl=="track" || this.pageUrl == null){ 
            this.fontColor1="white";
            this.fontColor2="black";
            this.transformValue="translateX(0)";
            this.clicked("track");
        }
        else{
            this.fontColor1="black";
            this.fontColor2="white";
            this.transformValue="translateX(100%)";
            this.clicked("proof");
        }
    });

    

    this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
    };
  }

  ngOnDestroy(): void {
    // Prevent memory leaks
    this.paramsSub.unsubscribe();


}

  clicked(choice:String){
    if(choice=="track"){

        this.trackPage=true;
        this.proofPage=false;

      let tabcontent1a = document.getElementById("trackShipmentButton");
      tabcontent1a.style.color="white";
      let tabcontent2a = document.getElementById("deliveryProofButton");
      tabcontent2a.style.color="black";
      let transform = document.getElementById("switch");
      transform.style.transform="translateX(0px)";
      transform.style.transition="0.1s";

      this.proofDisplay = false;

      this.trackCode="";
      this.inputTrackingNumber="";
      this.inputSenderContactNumber="";
      this.inputReceiverContactNumber="";
      this.inputAccountNumber="";
    }
    else{

    this.proofPage=true;
    this.trackPage=false;

    let tabcontent1a = document.getElementById("trackShipmentButton");
    tabcontent1a.style.color="black";
    let tabcontent2a = document.getElementById("deliveryProofButton");
    tabcontent2a.style.color="white";
    let transform = document.getElementById("switch");
    transform.style.transform="translateX(100%)";
    transform.style.transition="0.1s";
      
      this.trackerDisplay = false;

      this.trackCode="";
      this.inputTrackingNumber="";
      this.inputSenderContactNumber="";
      this.inputReceiverContactNumber="";
      this.inputAccountNumber="";
    }
  }

  getTrackerData(elementId:any): void{    

      this.visible = true;
      const trackerStr = this.trackCode
          //console.log("test track code", this.trackCode)
      var str_array = trackerStr.split(',');

      const dataArr = []

      for(var i = 0; i < str_array.length; i++) {
          // Trim the excess whitespace.
          str_array[i] = str_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
          // Add additional code here, such as:
          // console.log('tracker string: ' + str_array[i])

          dataArr.push(str_array[i])
      }


      let data = { 
          "SearchType" : "WayBillNumber",
          "WayBillNumber" : dataArr 
      }

      this.apiService.postTracker(data).subscribe((res: any) => {
          
          this.trackerDisplay = true

          // this.trackerArr = res
          this.trackerList = res
          console.log('this.trackerList', this.trackerList)
          let trackerData = []

          this.trackerList[0].forEach(element => {
              //console.log('element', element)
              
              switch(element.StatusCode){
                  case 'WB004':
                      var des = element.Description;
                      des = des.replace("Manifest Out Scan completed at Pickup branch","Checked Out and Departed to Branch");
                      element.Description = des.split("on")[0];
                      break;
                  case 'WB009':
                      var des = element.Description;
                      des = des.replace("Manifest Out Scan completed at Pickup Hub","Checked Out and Departed to Hub");
                      element.Description = des.split("on")[0];
                      break;
                  case 'WB013':
                      var des = element.Description;
                      des = des.replace("Manifest Out Scan completed","Transit Cage Out");
                      element.Description = des.split("on")[0];
                      break;
                  case 'WB017':
                      var des = element.Description;
                      des = des.replace("Ready for Delivery","Parcel has Arrived" );
                      element.Description = des;
                      break;
                  case 'WB005': case 'WB007': case 'WB010': case 'WB014':
                  case 'WB016': case 'WB019': case 'WB022': case 'WB023':
                  case 'WB025': case 'WB026':
                      delete element.Description;
                      delete element.LastModifiedDate;
                      delete element.LastModifiedOn;
                      delete element.LastModifiedTime;
                      delete element.NextLocation;
                      delete element.Status;
                      delete element.StatusCode;
                      delete element.TransitLocation;
                      delete element.UndelCode;
                      delete element.UndelReason;
                      delete element.WayBillNumber;  
                      break;
                  default:
                      var des = element.Description;
                      element.Description = des.split("on")[0];
                      break;               
              }

              if(element.StatusCode == "WB020"){

                  switch (element.UndelCode) {
                      case 'V001':
                          element.Description = "UnDelivered (Consignee not available)"
                          break;
                      case 'V002':
                          element.Description = "UnDelivered (Incomplete Address)"
                          break;
                      case 'V003':
                          element.Description = "UnDelivered (Return To Shipper (RTS))"
                          break;
                      case 'V004':
                          element.Description = "UnDelivered (Bad Weather)"
                          break;    
                      case 'V005':
                          element.Description = "UnDelivered (Office Collection)"
                          break; 
                      case 'V006':
                          element.Description = "UnDelivered (Unable to Complete)"
                          break; 
                      case 'V007':
                          element.Description = "UnDelivered (Short Piece(s))"
                          break;    
                      case 'V008':
                          element.Description = "UnDelivered (ODA Delivery - Delivery on selected days)"
                          break; 
                      case 'V009':
                          element.Description = "UnDelivered (Closed on arrival)"
                          break; 
                      case 'V010':
                          element.Description = "UnDelivered (No show at destination)"
                          break;    
                      case 'V011':
                          element.Description = "UnDelivered (Return to origin)"
                          break; 
                      case 'V012':
                          element.Description = "UnDelivered (Suspected lost)"
                          break; 
                      case 'V013':
                          element.Description = "UnDelivered (Suspected Damage)"
                          break;    
                      case 'V014':
                          element.Description = "UnDelivered (Misrouted)"
                          break; 
                      case 'V015':
                          element.Description = "UnDelivered (Wrong IC/Passport no.)"
                          break; 
                      case 'V016':
                          element.Description = "UnDelivered (COD amount not ready)"
                          break; 
                      case 'V017':
                          element.Description = "UnDelivered (Consignee Shifted)"
                          break; 
                      case 'V018':
                          element.Description = "UnDelivered (Unable to contact consignee)"
                          break;    
                      case 'V019':
                          element.Description = "UnDelivered (Cancel order)"
                          break; 
                      case 'V020':
                          element.Description = "UnDelivered (Consignee refused to accept)"
                          break; 
                      case 'V021':
                          element.Description = "UnDelivered (Change delivery date)"
                          break;    
                      case 'V022':
                          element.Description = "UnDelivered (Restrictions delivery areas)"
                          break; 
                      case 'V023':
                          element.Description = "UnDelivered (Business closed down)"
                          break; 
                      default:
                          break;
                  }
              }

              
          });

          this.trackerList.forEach(trackerID => {

              // check 1st object since it is the latest status 
              let trackingstatus = trackerID[0]

              console.log('tracking status: ', trackingstatus)

              switch (trackingstatus.Status) {
                  case "Delivered":
                      this.imageTracker="./assets/image/TRACKING/DELIVERED.png"
                      break;
                  case "Out for Delivery":
                      this.imageTracker="./assets/image/TRACKING/OFD.png"
                      break;
                  case "Order Placed":
                      this.imageTracker="./assets/image/TRACKING/BOOKED.png"
                      break;
                  default:
                      // all other status will be in transit status 
                      this.imageTracker="./assets/image/TRACKING/INTRANSIT.png"
                      break;
              }

              trackerData.push({"data" : trackerID, "image" : this.imageTracker})
      
          });
          
          this.trackerListRecon = trackerData
          console.log('json data: ', this.trackerListRecon)

          var newArray :any = {};
          newArray = this.trackerListRecon[0].data.filter(value => Object.keys(value).length !== 0 );
          this.trackerListRecon[0].data = newArray
          console.log('json data2 : ', this.trackerListRecon)
          this.trackCode = ""
          window.history.replaceState(null, document.title, "/tracking")


      }, error => {
          // Swal.fire("Backend Error!", "Error : <small style='color: red; font-style: italic;'>" + error.error.message + "</small>", "error")

          this.trackerDisplay = false;

          // looking for ShipmentRef

          let data = { 
              "SearchType" : "ShipmentRef",
              "ShipmentRef" : dataArr 
          }

          this.apiService.postTracker(data).subscribe((res: any) => {
              // console.log('raw resp:', res)
      
              this.trackerDisplay = true
      
              this.trackerList = res

              console.log("Track:" + this.trackerList)
      
              let trackerData = []

              this.trackerList[0].forEach(element => {
                  //console.log('element', element)
      
                  if(element.StatusCode == "WB020"){
      
                      switch (element.UndelCode) {
                          case 'V001':
                              element.Description = "UnDelivered (Consignee not available)"
                              break;
                          case 'V002':
                              element.Description = "UnDelivered (Incomplete Address)"
                              break;
                          case 'V003':
                              element.Description = "UnDelivered (Return To Shipper (RTS))"
                              break;
                          case 'V004':
                              element.Description = "UnDelivered (Bad Weather)"
                              break;    
                          case 'V005':
                              element.Description = "UnDelivered (Office Collection)"
                              break; 
                          case 'V006':
                              element.Description = "UnDelivered (Unable to Complete)"
                              break; 
                          case 'V007':
                              element.Description = "UnDelivered (Short Piece(s))"
                              break;    
                          case 'V008':
                              element.Description = "UnDelivered (ODA Delivery - Delivery on selected days)"
                              break; 
                          case 'V009':
                              element.Description = "UnDelivered (Closed on arrival)"
                              break; 
                          case 'V010':
                              element.Description = "UnDelivered (No show at destination)"
                              break;    
                          case 'V011':
                              element.Description = "UnDelivered (Return to origin)"
                              break; 
                          case 'V012':
                              element.Description = "UnDelivered (Suspected lost)"
                              break; 
                          case 'V013':
                              element.Description = "UnDelivered (Suspected Damage)"
                              break;    
                          case 'V014':
                              element.Description = "UnDelivered (Misrouted)"
                              break; 
                          case 'V015':
                              element.Description = "UnDelivered (Wrong IC/Passport no.)"
                              break; 
                          case 'V016':
                              element.Description = "UnDelivered (COD amount not ready)"
                              break; 
                          case 'V017':
                              element.Description = "UnDelivered (Consignee Shifted)"
                              break; 
                          case 'V018':
                              element.Description = "UnDelivered (Unable to contact consignee)"
                              break;    
                          case 'V019':
                              element.Description = "UnDelivered (Cancel order)"
                              break; 
                          case 'V020':
                              element.Description = "UnDelivered (Consignee refused to accept)"
                              break; 
                          case 'V021':
                              element.Description = "UnDelivered (Change delivery date)"
                              break;    
                          case 'V022':
                              element.Description = "UnDelivered (Restrictions delivery areas)"
                              break; 
                          case 'V023':
                              element.Description = "UnDelivered (Business closed down)"
                              break; 
                          default:
                              break;
                      }
                  }
              });
      
              this.trackerList.forEach(trackerID => {
      
                  // check 1st object since it is the latest status 
                  let trackingstatus = trackerID[0]
      
                  // console.log('tracking status: ', trackingstatus)
      
                  switch (trackingstatus.Status) {
                      case "Delivered":
                          this.imageTracker="./assets/image/TRACKING/DELIVERED.png"
                          break;
                      case "Out for Delivery":
                          this.imageTracker="./assets/image/TRACKING/OFD.png"
                          break;
                      case "Order Placed":
                          this.imageTracker="./assets/image/TRACKING/BOOKED.png"
                          break;
                      default:
                          // all other status will be in transit status 
                          this.imageTracker="./assets/image/TRACKING/INTRANSIT.png"
                          break;
                  }
      
                  trackerData.push({"data" : trackerID, "image" : this.imageTracker})
          
              });
      
              this.trackerListRecon = trackerData
              // console.log('json data: ', this.trackerListRecon)

              var newArray :any = {};
              newArray = this.trackerListRecon[0].data.filter(value => Object.keys(value).length !== 0 );
              this.trackerListRecon[0].data = newArray

              this.trackCode = ""
              window.history.replaceState(null, document.title, "/tracking")
      
          }, error => {
              Swal.fire("Not Found!", "Error : <small style='color: red; font-style: italic;'>Item Not Found!</small>", "error")
              this.trackerDisplay = false
              
          })
          
      }) 

      setTimeout(() => {;
          this.visible = false
          this.viewportScroller.scrollToAnchor(elementId);
      }, 1500);

      this.trackerDisplay = true;
  }

  proofSubmit(proofForm){
    this.visible = true;        

    console.log(this.inputTrackingNumber);
    console.log(this.inputSenderContactNumber);
    console.log(this.inputReceiverContactNumber);
    console.log(this.inputAccountNumber);

    this.inputTrackingNumber = "";
    this.inputSenderContactNumber = "";
    this.inputReceiverContactNumber = "";
    this.inputAccountNumber = "";

    this.proofDisplay=true;
  }

  goToPortal(){
      window.open('https://www.lineclearexpressonline.com/#/auth/login');
  }
 
}